import type { FC } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { Grid, Typography } from '@packages/shared';
import { TopCategoryItem } from '../TopCategoryItem';
import type { TopCategory } from '../../api/rest/types';

const messages = defineMessages({
  headline: {
    id: 'search.topCategories.headline',
    defaultMessage: 'Stöbere in unseren Kategorien',
  },
});

export type TopCategoriesProps = {
  /** The top categories to display */
  topCategories: TopCategory[];
};

/**
 * TopCategories component displays a grid of top categories to browse in case of no search results.
 * */
export const TopCategories: FC<TopCategoriesProps> = ({ topCategories }) => (
  <>
    <Typography variant="h5">
      <FormattedMessage {...messages.headline} />
    </Typography>
    <Grid container spacing={1} sx={{ marginTop: 2 }} columns={{ xs: 12, sm: 12, md: 10 }}>
      {topCategories.map((topCategory) => (
        <Grid item xs={6} sm={4} md={2} lg key={topCategory.id}>
          <TopCategoryItem categoryItem={topCategory} />
        </Grid>
      ))}
    </Grid>
  </>
);
